module.exports = __webpack_public_path__ + "img/MES_Background.c3724486.png";